import(/* webpackMode: "eager", webpackExports: ["useUser"] */ "/home/will/Documents/Business/wise/repos/wise/node_modules/@auth0/nextjs-auth0/dist/client/hooks/use-user.js");
;
import(/* webpackMode: "eager", webpackExports: ["Auth0Provider"] */ "/home/will/Documents/Business/wise/repos/wise/node_modules/@auth0/nextjs-auth0/dist/client/providers/auth0-provider.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/will/Documents/Business/wise/repos/wise/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/will/Documents/Business/wise/repos/wise/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/home/will/Documents/Business/wise/repos/wise/node_modules/react-hot-toast/dist/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["MobileFrameClientSide"] */ "/home/will/Documents/Business/wise/repos/wise/site/domains/layout/components/MobileFrameClientSide.tsx");
;
import(/* webpackMode: "eager" */ "/home/will/Documents/Business/wise/repos/wise/site/domains/layout/images/wide-logo.svg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/will/Documents/Business/wise/repos/wise/site/domains/users/components/LowerMenuItemDetails.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DatabaseProvider"] */ "/home/will/Documents/Business/wise/repos/wise/site/domains/wordcloudplus/domains/database/database/provider.tsx");
